 <!-- @if (this.viewMode === responsiveMode.horizontal) {
  <app-theme-controls></app-theme-controls>
  <app-theme-playground></app-theme-playground>
} -->

<div
  class="shell"
  [lxResponsiveClass]="shellResponsiveClass"
  [attr.data-theme]="theme"
  [attr.data-style]="style">
  <ng-content></ng-content>
</div>
